import { FC, useEffect } from "react";
import { hotjar } from "react-hotjar";
import { ENABLE_TRACKING_SCRIPTS } from "~features/tracking/config";

const HOTJAR_ID = process.env.HOTJAR_PRODUCTION_ID;

export const HotjarScript: FC = () => {
  useEffect(() => {
    if (ENABLE_TRACKING_SCRIPTS && HOTJAR_ID) {
      hotjar.initialize((HOTJAR_ID as unknown) as number, 6);
    }
  }, []);

  return null;
};
